import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CreatorStatsService {
  private readonly http = inject(HttpClient);

  trackSearchImpressions(creatorIds: string[], businessAccountId?: string): Observable<void> {
    const url = `${environment.shout_api.url}/creator-stats/track-search-impressions`;
    const body: { creatorIds: string[]; businessAccountId?: string } = { creatorIds };
    if (businessAccountId) {
      body.businessAccountId = businessAccountId;
    }
    return this.http.post<void>(url, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  trackProfileView(creatorId: string, businessAccountId?: string): Observable<void> {
    const url = `${environment.shout_api.url}/creator-stats/track-profile-view`;
    const body: { creatorId: string; businessAccountId?: string } = { creatorId };
    if (businessAccountId) {
      body.businessAccountId = businessAccountId;
    }
    return this.http.post<void>(url, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
}
